import Vue from "vue";

import moment from "moment";
Vue.mixin({
  methods: {
    $getShowingPage(page, filter) {
      let result = {
        startPage: (page - 1) * filter.perPage + 1,
        endPage: page * filter.perPage,
      };
      return result;
    },
    formatDate(value) {
      if (value) {
        let newDate = new Date(value);
        newDate.setHours(newDate.getHours());
        const date = `${moment(value).format(this.$formatDate)} (${moment(
          newDate
        ).format(this.$formatTime)})`;
        return date;
      }
    },
  },
});
